import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MainService } from 'BaseServices/main-service';
import { EquipmentBorrowDetailDTO } from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';
import { dialogInputTitleComponent } from 'src/app/elements/dialog-input-title.component';

@Component({
  selector: 'app-equipment-borrow-tab',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    dialogInputTitleComponent,
  ],
  templateUrl: './equipment-borrow-tab.component.html',
  styleUrls: ['./equipment-borrow-tab.component.css'],
})
export class EquipmentBorrowTabComponent implements OnInit {
  equipmentId = 0;

  equipmentBorrow: EquipmentBorrowDetailDTO = {
    id: 0,
    initials: '',
    borrowedDate: new Date(),
    expectedReturnDate: new Date(),
    returnedDate: null as any,
    borrowedComment: '',
    returnedComment: '',
    locationName: '',
    projectNr: '',
    equipmentId: 0,
  };

  constructor(
    private mainService: MainService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.activatedRoute.parent?.paramMap.subscribe((params) => {
      this.equipmentId = Number(params.get('id') ?? 0);
      this.equipmentBorrow.equipmentId = this.equipmentId;

      console.log('equipmentId:', this.equipmentId);
    });
  }

  get isBorrowSaveDisabled(): boolean {
    return (
      !this.equipmentId ||
      !this.equipmentBorrow.initials ||
      this.equipmentBorrow.initials.trim().length === 0 ||
      !(this.equipmentBorrow.expectedReturnDate instanceof Date)
    );
  }

  saveBorrow(): void {
    if (this.isBorrowSaveDisabled) return;

    const payload: any = {
      EquipmentId: this.equipmentId,
      Initials: (this.equipmentBorrow.initials ?? '').trim(),
      BorrowedDate: new Date(),
      ExpectedReturnDate: this.equipmentBorrow.expectedReturnDate,
      BorrowedComment: (this.equipmentBorrow.borrowedComment ?? '').trim(),
      ProjectNr: (this.equipmentBorrow.projectNr ?? '').trim(),
      LocationName: (this.equipmentBorrow.locationName ?? '').trim(),
    };

    this.mainService.add<any, any>('Equipmentborrows', payload).subscribe({
      next: () => {
        Swal.fire({
          title: 'Gemt',
          text: 'Udstyret er udlånt.',
          icon: 'success',
          confirmButtonText: 'Ok',
        }).then(() => {
          this.router.navigate(['../../søgudstyr'], {
            relativeTo: this.activatedRoute,
          });
        });
      },
      error: (err) => {
        console.error(err);
        Swal.fire({
          title: 'Fejl',
          text: 'Kunne ikke gemme udlån.',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      },
    });
  }
}
